var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H30",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9H30",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13H30",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5595 15.602C12.5968 17.7227 14.3158 19.4339 16.4412 20.4615C16.5967 20.5352 16.7687 20.5671 16.9403 20.5541C17.1119 20.5412 17.2771 20.4837 17.4198 20.3875L20.5492 18.3007C20.6877 18.2084 20.8469 18.1521 21.0126 18.1369C21.1782 18.1217 21.3451 18.148 21.498 18.2135L27.3526 20.7227C27.5515 20.8071 27.7175 20.954 27.8257 21.141C27.9339 21.3281 27.9783 21.5452 27.9524 21.7597C27.7673 23.2078 27.0608 24.5387 25.9652 25.5033C24.8695 26.4679 23.4598 27 22 27.0001C17.4913 27.0001 13.1673 25.2091 9.97919 22.0209C6.79107 18.8328 5 14.5088 5 10.0001C5.00008 8.54034 5.53224 7.13064 6.49685 6.03497C7.46146 4.9393 8.79237 4.2328 10.2404 4.04775C10.4549 4.02179 10.672 4.06625 10.8591 4.17443C11.0461 4.2826 11.193 4.44864 11.2775 4.64753L13.7888 10.5073C13.8537 10.6588 13.8802 10.8241 13.8658 10.9884C13.8514 11.1526 13.7967 11.3108 13.7064 11.4488L11.6268 14.6263C11.5322 14.7692 11.4762 14.9342 11.4644 15.1053C11.4526 15.2763 11.4854 15.4475 11.5595 15.602V15.602Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneHistory);
export default __webpack_public_path__ + "static/media/PhoneHistory.54a4081b52c649b1f333eeb37c137757.svg";
export { ForwardRef as ReactComponent };